"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    "colorBrandPrimary": "#ff2b85",
    "colorBrandSecondary": "#687580",
    "colorBrandDark": "#c21760",
    "colorBrandHighlight": "#fdf2f7",
    "colorGradientBrand": "linear-gradient(90deg, #ff2b85 0%, #e21b70 100%)",
    "colorGradientDark": "#e21b70",
    "colorGradientLight": "#ff2b85",
    "colorInteractionPrimary": "#e21b70",
    "colorInteractionSecondary": "#666666",
    "colorInteractionTertiary": "#ed66a0",
    "colorInteractionPrimaryHover": "#c21760",
    "colorInteractionSecondaryHover": "#333333",
    "colorInteractionPrimaryFeedback": "#fdf2f7",
    "colorInfoBannerCta": "#c21760",
    "colorOnInteractionPrimary": "#ffffff",
    "colorOnInteractionPrimaryHover": "#ffffff",
    "colorOnInteractionSecondary": "#e21b70",
    "colorOnInteractionSecondaryHover": "#c21760",
    "colorInteractionBackgroundHover": "#fdf2f7",
    "colorInteractionTextHover": "#c21760",
    "colorInteractionFocus": "#ff2b85",
    "colorInteractionFocusReversed": "#fdf2f7",
    "colorInteractionReversedWhiteOpacity15": "#FFFFFF26",
    "colorInteractionReversedWhiteOpacity30": "#FFFFFF4d",
    "colorInteractionReversedWhiteOpacity50": "#FFFFFF80",
    "colorMainText": "#c21760",
    "colorExpTimerBgCover": "#c21760",
    "colorExpTimerDigitCover": "#ffffff",
    "colorTiersSubtitleText": "#ffffff",
    "colorTier3SubtitleText": "#ffffff",
    "colorTier1Tile": "#707070",
    "colorTier2Tile": "#c21760",
    "colorTier3Tile": "#2B3035",
    "colorHowItWorksText": "#c21760",
    "colorHowItWorksIconBg": "#c21760",
    "colorTimerBg": "#c21760",
    "colorTimerDigit": "#ffffff",
    "colorNextTiersText": "#ffffff",
    "colorNextTier3Text": "#ffffff",
    "colorDefaultTier": "#ffffff",
    "colorRdpSheetTier1": "#ff2b85",
    "colorRdpSheetTier2": "#c21760",
    "colorRdpSheetTier3": "#2B3035",
    "colorRdpSheetTier4": "#707070",
    "colorStarBgTier1": "#ff2b85",
    "colorStarBgTier2": "#c21760",
    "colorStarBgTier3": "#2B3035",
    "colorRdpSheetTierTextBg1": "#fef6f9",
    "colorRdpSheetTierTextBg2": "#fdf2f7",
    "colorRdpSheetTierTextBg3": "#E3E6E8",
    "colorRdpSheetTierTextBg4": "#dcdcdc",
    "colorNextTier1Rdp": "#ff2b85",
    "colorNextTier2Rdp": "#c21760",
    "colorNextTier3Rdp": "#2B3035",
    "colorNextTier4Rdp": "#707070",
    "colorPopupText": "#ffffff",
    "colorGenericBg": "#fad9e7",
    "colorExpDealBg": "#c21760",
    "colorExpDealText": "#ffffff",
    "colorExpStarBgDefault": "#dcdcdc",
    "colorExpStarBgActive": "#e21b70",
    "colorExpFooterTextDefault": "#707070",
    "colorExpFooterTextActive": "#e21b70",
    "colorExpTimerContainer": "#ffffff",
    "colorExpFooterTimerBg": "#e21b70",
    "colorExpFooterTimerDigit": "#ffffff",
    "colorExp2GenericBg": "#fef6f9",
    "colorExp2DiscountBg": "#c21760",
    "colorRating": "#ffb413",
    "colorRatingBackground": "#f6b2cf",
    "colorRatingFeedbackBackground": "#fdf2f7",
    "colorRatingFeedbackActive": "#e21b70",
    "colorPopularIcon": "#ffb413",
    "colorRatingOutline": "#e03000",
    "colorDealHighlightLvl1": "#fdf2f7",
    "colorDealHighlightLvl2": "#fad9e7",
    "colorDealTertiary": "#f6b2cf",
    "colorDealSecondary": "#ed66a0",
    "colorDealPrimary": "#c21760",
    "colorDealTextOnWhite": "#e21b70",
    "colorDealBannerText": "#c21760",
    "colorPriceEmphasis": "#333333",
    "colorTagDealBackground": "#e21b70",
    "colorTagDealText": "#ffffff",
    "colorTagBestCityBackground": "#2B3035",
    "colorTagBestCityText": "#ffffff",
    "colorRatingLightTagIcon": "#ffffff",
    "colorRatingLightTagText": "#ffffff",
    "colorTagPrimaryText": "#ffffff",
    "colorTagPrimaryBackground": "#e21b70",
    "colorPopularHighlight": "#ffedc6",
    "colorPopularTagText": "#333333",
    "colorPopularTagIcon": "#ffb413",
    "colorTagSponsoredBackground": "#333333cc",
    "colorTagSuccessText": "#ffffff",
    "colorTagSecondaryText": "#c21760",
    "colorTagSecondaryBackground": "#fdf2f7",
    "colorInformation": "#56616A",
    "colorError": "#bb2800",
    "colorSuccess": "#3c8264",
    "colorWarning": "#fcc54c",
    "colorInformationHighlight": "#EEF0F1",
    "colorErrorHighlight": "#fdefeb",
    "colorSuccessHighlight": "#f0f5f3",
    "colorWarningHighlight": "#fffbf1",
    "colorSpecial1": "#f6b2cf",
    "colorSpecial2": "#ed66a0",
    "colorSpecial3": "#ff2b85",
    "colorSpecial4": "#E3E6E8",
    "colorSpecial5": "#B9C0C6",
    "colorSpecial6": "#919DA6",
    "colorSpecial7": "#2B3035",
    "colorNeutralPrimary": "#333333",
    "colorNeutralSecondary": "#707070",
    "colorNeutralInactive": "#cacaca",
    "colorNeutralBorder": "#dcdcdc",
    "colorNeutralDivider": "#ebebeb",
    "colorNeutralSurface": "#f7f7f7",
    "colorWhite": "#ffffff",
    "colorTransparent": "#00000000",
    "colorDark4": "#3333330a",
    "colorDark64": "#333333a3",
    "colorLight80": "#ffffffcc",
    "colorLight56": "#ffffff8f",
    "colorAltScreenSurface": "#ffffff",
    "colorSurfaceGradientTop": "#fdf2f7",
    "colorSurfaceGradientBottom": "#f7f7f7",
    "colorSurfaceGradient": "linear-gradient(145deg, #fdf2f7 0%, #f7f7f7 100%)",
    "colorItemModifierRequiredBackground": "#fdf2f7",
    "colorItemModifierRequiredHover": "#fad9e7",
    "colorItemModifierRequiredPopular": "#f6b2cf",
    "colorProMemberHoverBackground": "#fad9e7",
    "colorProMemberTextActive": "#c21760",
    "colorDiscountHoverBackground": "#fad9e7",
    "colorDiscountTextActive": "#c21760",
    "colorLoyaltyHoverBackground": "#ffe4aa",
    "colorLoyaltyTextIdle": "#333333",
    "colorLoyaltyTextActive": "#333333",
    "colorLoyaltyIcon": "#333333",
    "colorProHoverBackground": "#ebebeb",
    "colorProTextActive": "#c21760",
    "colorIlluSecondaryDark": "#687580",
    "colorIlluSecondary75": "#ed66a0",
    "colorIlluSecondary50": "#f6b2cf",
    "colorIlluSecondary30": "#fad9e7",
    "colorIlluSecondary20": "#ffd271",
    "colorIlluSecondary15": "#ffedc6",
    "colorIlluSecondary10": "#E3E6E8",
    "colorTileNavigationPrimary800": "#e21b70",
    "colorTileNavigationPrimary700": "#ff2b85",
    "colorTileNavigationPrimary600": "#ed66a0",
    "colorTileNavigationPrimary500": "#f6b2cf",
    "colorTileListPrimary400": "#fad9e7",
    "colorTileListPrimary300": "#fad9e7",
    "colorTileListPrimary200": "#fad9e7",
    "colorTileListPrimary100": "#fad9e7",
    "colorTileNavigationSecondary800": "#ffd271",
    "colorTileNavigationSecondary700": "#ffdb8d",
    "colorTileNavigationSecondary600": "#ffe4aa",
    "colorTileNavigationSecondary500": "#ffe9b8",
    "colorTileListSecondary400": "#ffe9b8",
    "colorTileListSecondary300": "#ffe9b8",
    "colorTileListSecondary200": "#ffe9b8",
    "colorTileListSecondary100": "#ffe9b8",
    "colorTileNavigationTertiary800": "#919DA6",
    "colorTileNavigationTertiary700": "#B9C0C6",
    "colorTileNavigationTertiary600": "#C7CDD1",
    "colorTileNavigationTertiary500": "#E3E6E8",
    "colorTileListTertiary400": "#EEF0F1",
    "colorTileListTertiary300": "#EEF0F1",
    "colorTileListTertiary200": "#EEF0F1",
    "colorTileListTertiary100": "#EEF0F1",
    "colorSocialMediaFacebook": "#1877F2",
    "colorSocialMediaFacebookHover": "#1364CE",
    "colorFocusRingLight": "#B2E2F0",
    "colorFocusRingDark": "#0067A0",
    "bdsCornerRadiusBase": "8px",
    "bdsCornerRadiusContainer": "12px",
    "bdsCornerRadiusMedia": "8px",
    "bdsCornerRadiusOverlay": "16px",
    "bdsCornerRadiusButton": "8px",
    "bdsCornerRadiusPressed": "12px",
    "bdsCornerRadiusField": "8px",
    "bdsCornerRadiusSwitch": "8px",
    "bdsCornerRadiusPill": "9999px",
    "bdsCornerRadiusMini": "4px",
    "bdsCornerRadiusCircle": "9999px",
    "colorTabsquarePrimary": "#333333",
    "bdsTypographyBgLargeFontFamily": "'Open Sans'",
    "bdsTypographyBgLargeFontSize": "160px",
    "bdsTypographyBgLargeFontWeight": "700",
    "bdsTypographyBgLargeLineHeight": "1.3",
    "bdsTypographyBgMediumFontFamily": "'Open Sans'",
    "bdsTypographyBgMediumFontSize": "120px",
    "bdsTypographyBgMediumFontWeight": "700",
    "bdsTypographyBgMediumLineHeight": "1.3",
    "bdsTypographyBgSmallFontFamily": "'Open Sans'",
    "bdsTypographyBgSmallFontSize": "80px",
    "bdsTypographyBgSmallFontWeight": "700",
    "bdsTypographyBgSmallLineHeight": "1.3",
    "bdsTypographyTitleXxlargeFontFamily": "'Open Sans'",
    "bdsTypographyTitleXxlargeFontSize": "40px",
    "bdsTypographyTitleXxlargeFontWeight": "400",
    "bdsTypographyTitleXxlargeLineHeight": "1.3",
    "bdsTypographyTitleXlargeFontFamily": "'Open Sans'",
    "bdsTypographyTitleXlargeFontSize": "32px",
    "bdsTypographyTitleXlargeFontWeight": "600",
    "bdsTypographyTitleXlargeLineHeight": "1.3125",
    "bdsTypographyTitleXlargeSecondaryFontFamily": "'Open Sans'",
    "bdsTypographyTitleXlargeSecondaryFontSize": "32px",
    "bdsTypographyTitleXlargeSecondaryFontWeight": "400",
    "bdsTypographyTitleXlargeSecondaryLineHeight": "1.3125",
    "bdsTypographyTitleLargeFontFamily": "'Open Sans'",
    "bdsTypographyTitleLargeFontSize": "24px",
    "bdsTypographyTitleLargeFontWeight": "700",
    "bdsTypographyTitleLargeLineHeight": "1.333333333",
    "bdsTypographyTitleLargeSecondaryFontFamily": "'Open Sans'",
    "bdsTypographyTitleLargeSecondaryFontSize": "24px",
    "bdsTypographyTitleLargeSecondaryFontWeight": "400",
    "bdsTypographyTitleLargeSecondaryLineHeight": "1.333333333",
    "bdsTypographyTitleMediumFontFamily": "'Open Sans'",
    "bdsTypographyTitleMediumFontSize": "18px",
    "bdsTypographyTitleMediumFontWeight": "700",
    "bdsTypographyTitleMediumLineHeight": "1.555555556",
    "bdsTypographyTitleMediumSecondaryFontFamily": "'Open Sans'",
    "bdsTypographyTitleMediumSecondaryFontSize": "18px",
    "bdsTypographyTitleMediumSecondaryFontWeight": "400",
    "bdsTypographyTitleMediumSecondaryLineHeight": "1.555555556",
    "bdsTypographyTitleSmallFontFamily": "'Open Sans'",
    "bdsTypographyTitleSmallFontSize": "16px",
    "bdsTypographyTitleSmallFontWeight": "600",
    "bdsTypographyTitleSmallLineHeight": "1.5",
    "bdsTypographyLabelLargeFontFamily": "'Open Sans'",
    "bdsTypographyLabelLargeFontSize": "16px",
    "bdsTypographyLabelLargeFontWeight": "600",
    "bdsTypographyLabelLargeLineHeight": "1.5",
    "bdsTypographyLabelMediumFontFamily": "'Open Sans'",
    "bdsTypographyLabelMediumFontSize": "14px",
    "bdsTypographyLabelMediumFontWeight": "600",
    "bdsTypographyLabelMediumLineHeight": "1.571428571",
    "bdsTypographyLabelSmallFontFamily": "'Open Sans'",
    "bdsTypographyLabelSmallFontSize": "12px",
    "bdsTypographyLabelSmallFontWeight": "600",
    "bdsTypographyLabelSmallLineHeight": "1.5",
    "bdsTypographyLabelSmallSecondaryFontFamily": "'Open Sans'",
    "bdsTypographyLabelSmallSecondaryFontSize": "12px",
    "bdsTypographyLabelSmallSecondaryFontWeight": "400",
    "bdsTypographyLabelSmallSecondaryLineHeight": "1.5",
    "bdsTypographyLabelXsmallFontFamily": "'Open Sans'",
    "bdsTypographyLabelXsmallFontSize": "10px",
    "bdsTypographyLabelXsmallFontWeight": "600",
    "bdsTypographyLabelXsmallLineHeight": "1.6",
    "bdsTypographyParagraphMediumFontFamily": "'Open Sans'",
    "bdsTypographyParagraphMediumFontSize": "16px",
    "bdsTypographyParagraphMediumFontWeight": "400",
    "bdsTypographyParagraphMediumLineHeight": "1.5",
    "bdsTypographyParagraphSmallFontFamily": "'Open Sans'",
    "bdsTypographyParagraphSmallFontSize": "14px",
    "bdsTypographyParagraphSmallFontWeight": "400",
    "bdsTypographyParagraphSmallLineHeight": "1.571428571",
    "bdsTypographyParagraphXsmallFontFamily": "'Open Sans'",
    "bdsTypographyParagraphXsmallFontSize": "12px",
    "bdsTypographyParagraphXsmallFontWeight": "600",
    "bdsTypographyParagraphXsmallLineHeight": "1.833333333",
    "bdsTypographyParagraphXsmallSecondaryFontFamily": "'Open Sans'",
    "bdsTypographyParagraphXsmallSecondaryFontSize": "12px",
    "bdsTypographyParagraphXsmallSecondaryFontWeight": "400",
    "bdsTypographyParagraphXsmallSecondaryLineHeight": "1.833333333",
    "bdsTypographyRibbonBaseFontFamily": "'Open Sans'",
    "bdsTypographyRibbonBaseFontSize": "14px",
    "bdsTypographyRibbonBaseFontWeight": "600",
    "bdsTypographyRibbonBaseLineHeight": "1.571428571",
    "bdsTypographyMiniBaseFontFamily": "'Open Sans'",
    "bdsTypographyMiniBaseFontSize": "10px",
    "bdsTypographyMiniBaseFontWeight": "700",
    "bdsTypographyMiniBaseLineHeight": "1.6",
    "bdsSpacingXxxs": "2px",
    "bdsSpacingXxs": "4px",
    "bdsSpacingXs": "8px",
    "bdsSpacingSt": "12px",
    "bdsSpacingSm": "16px",
    "bdsSpacingMd": "24px",
    "bdsSpacingLg": "32px",
    "bdsSpacingXl": "48px",
    "bdsSpacingXxl": "64px",
    "bdsSpacingXxxl": "80px",
    "bdsElevationLow": "0px 0px 24px 0px rgba(0,0,0,0.16)",
    "bdsElevationMedium": "0px 0px 48px 0px rgba(0,0,0,0.24)",
    "bdsElevationHigh": "0px 0px 96px 0px rgba(0,0,0,0.24)",
    "bdsMotionEasingEntrance": "cubic-bezier(0, 0, 0.1, 1)",
    "bdsMotionEasingExit": "cubic-bezier(0.52, 0, 1, 1)",
    "bdsMotionEasingStandard": "cubic-bezier(0.22, 0.1, 0.1, 1)",
    "bdsMotionEasingBounce": "cubic-bezier(0.35, 0.12, 0.14, 1.42)",
    "bdsMotionDelay50": "50ms",
    "bdsMotionDelay100": "100ms",
    "bdsMotionDelay150": "150ms",
    "bdsMotionDelay400": "400ms",
    "bdsMotionDelay600": "600ms",
    "bdsMotionDuration100": "100ms",
    "bdsMotionDuration150": "150ms",
    "bdsMotionDuration200": "200ms",
    "bdsMotionDuration250": "250ms",
    "bdsMotionDuration300": "300ms",
    "bdsMotionDuration350": "350ms",
    "bdsMotionDuration400": "400ms",
    "bdsMotionDuration450": "450ms",
    "bdsMotionDuration500": "500ms",
    "bdsMotionDuration600": "600ms",
    "bdsGridMinWidthSm": "528px",
    "bdsGridMinWidthMd": "768px",
    "bdsGridMinWidthLg": "960px",
    "bdsGridMinWidthXl": "1264px",
    "bdsGridMaxWidthSm": "767px",
    "bdsGridMaxWidthMd": "959px",
    "bdsGridMaxWidthLg": "1263px",
    "bdsGridMaxWidthXl": "1440px",
    "bdsGridColSm": "6",
    "bdsGridColMd": "6",
    "bdsGridColLg": "12",
    "bdsGridColXl": "12",
    "bdsGridGutterSm": "16px",
    "bdsGridGutterMd": "16px",
    "bdsGridGutterLg": "24px",
    "bdsGridGutterXl": "24px",
    "bdsGridMarginSm": "16px",
    "bdsGridMarginMd": "16px",
    "bdsGridMarginLg": "32px",
    "bdsGridMarginXl": "64px",
    "bdsZindexSurfaceBase": "1",
    "bdsZindexSurfaceRaised": "1",
    "bdsZindexSurfacePeaked": "1",
    "bdsZindexLowBase": "100",
    "bdsZindexLowRaised": "125",
    "bdsZindexLowPeaked": "150",
    "bdsZindexMediumBase": "200",
    "bdsZindexMediumRaised": "225",
    "bdsZindexMediumPeaked": "250",
    "bdsZindexHighBase": "300",
    "bdsZindexHighRaised": "325",
    "bdsZindexHighPeaked": "350",
};
